<template>
  <v-menu
    ref="menu"
    v-model="menu2"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="400px"
    min-width="200px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="access_time"
        readonly
        v-on="on"
        :disabled="disabled"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu2"
      v-model="time"
      format="24hr"
      width="280"
      scrollable
      @click:minute="$refs.menu.save(time)"
    ></v-time-picker>
  </v-menu>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "TimePicker",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Time",
    },
    disabled: {
      default: false,
    },
    timestamp: {
      default: false,
    },
    timezone: {
      default: null,
    },
    offset: {
      default: null,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class TimePicker extends (Vue, Themeable) {
  time = null;
  menu2 = false;
  date = null;
  secs = null;
  timezoneOffset = new Date().getTimezoneOffset() * 60;

  mounted() {
    this.timezoneOffset =
      this.offset == null ? new Date().getTimezoneOffset() * 60 : this.offset;
    this.onValueChange(this.value);
  }

  @Watch("offset")
  onOffsetChange(val) {
    this.timezoneOffset =
      val == null ? new Date().getTimezoneOffset() * 60 : val;
  }

  @Watch("time")
  onTimeChange(val, oldValue) {
    if (val === oldValue) return;

    if (val != null && val != "") {
      if (this.timestamp === false)
        this.$emit("input", parseFloat(val.replace(":", ".")));
      else {
        const v = this.$moment(this.date + val + this.secs).format("X");
        this.$emit("input", parseInt(v) + this.timezoneOffset);
      }
    } else {
      this.time = null;
      this.date = null;
    }
  }

  @Watch("value")
  onValueChange(value, oldValue) {
    if (value === oldValue) return;
    if (value == null || value == "") {
      this.date = null;
      this.time = null;
      this.secs = null;
      return;
    }
    if (this.timestamp !== false) {
      value = value * 1000;
      value = value - this.timezoneOffset * 1000;
      const iso = this.$moment(value).toISOString();
      this.date = iso.substr(0, 11);
      this.time = iso.substr(11, 5);
      this.secs = iso.substr(16);
      return;
    }
    this.time = value.toString().replace(".", ":");
    if (this.time.indexOf(":") == -1) {
      this.time = this.time + ":00";
    }
    if (value < 10) {
      this.time = "0" + this.time;
    }
    if (this.time.length == 4) {
      this.time = this.time + "0";
    }
  }
}
</script>
